import { LinkService } from '../_base/link.service'

/**
 * Replaces the LinkService DI registration.
 *
 * LinkService itself is kept: it extends `CommonLinkService` from the isomorphic `booksprout`
 * package and carries a dozen url-building methods that the mixins and templates call by name.
 * Rewriting those into a flat composable bag would churn every call site for no gain, so this
 * module owns the *instance* and its one-time `configure(homeUrl)` instead — which is all the
 * container was doing.
 *
 * `scopeToReviewer` is decided in the LinkService constructor from `IsReviewerApp()`, so the
 * instance is created lazily rather than at import time: under SSR, `IsReviewerApp()` reads
 * `process.env.SERVER` and the request path, and constructing at import time would freeze the
 * wrong answer into the module.
 */

let GlobalLink: LinkService | undefined

const useLink = () => {
  const link = (): LinkService => {
    if (!GlobalLink) {
      GlobalLink = new LinkService()
    }

    return GlobalLink
  }

  /**
   * `homeUrl` differs per app (bsConstants.APP.HOME_URLS.PUBLISHER and friends) and was passed
   * in from each app's container.ts.
   */
  const init = (homeUrl: string) => {
    link().configure(homeUrl)
  }

  const reset = () => {
    GlobalLink = void 0
  }

  return {
    init,
    link,
    reset
  }
}

export { useLink, GlobalLink }
